import { render, staticRenderFns } from "./SearchInput.vue?vue&type=template&id=56341921&scoped=true"
import script from "./SearchInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchInput.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SearchInput.vue?vue&type=style&index=0&id=56341921&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56341921",
  null
  
)

export default component.exports